import { useContext } from 'react'
import { AmplitudeContext } from './AmplitudeContext'

export default () => useContext(AmplitudeContext)?.analytics
